module.exports = __webpack_public_path__ + "media/images/flags/16/Kuwait-6bf571fad82674d1ccb68e892e5f9c49.png";